<template lang="pug">
  v-container.fill-height
    v-row
      v-col(:cols="12")
        template(
          v-if="$get(ad, `video`)")
          utility-video(
            ref="video"
            @touchstart="onClick"
            @remaining-time-updated="remainingTimeUpdated"
            @ended="onEnded"
            :is-playing.sync="isPlaying"
            :src="$get(ad, `video.src`)"
            type="video/mp4"
            muted
            style="width: 100%; border-radius: 12px; max-height: 72vh")
        template(v-else-if="$get(ad, `image`)")
          v-img(
            @click="onClick"
            :src="ad.image.src")
        div.text-center(v-if="remainingTime") {{ Math.ceil(remainingTime) }}s
        div.text-center.text-caption(style="position: absolute; bottom: 20px; left: 50%; transform: translate3d(-50%, 0, 0)")
          template(v-if="isPlaying") En visionnant cette annonce, vous rapportez environ
            strong  {{ Math.ceil($get(ad, `pricePerView`) / 100) }}
            | cts à
            strong  {{ $get(association, `user.name`) }}
          template(v-else) Regarder pour soutenir
            strong  {{ $get(association, `user.name`) }}
</template>

<script>
import { page, theme, injectRouteState } from '@iez/core'
import data from '@iez/lib/data/'
import router, { routeCurrent } from '@iez/core/router/'
import { ref, onUnmounted } from '@vue/composition-api'
import waitFor from '@iez/lib/wait-for/'
import dayjs from 'dayjs'
import UtilityVideo from '@iez/components/utility/video'
import handleValueOrFunction from '@iez/lib/handle-value-or-function/'

const route = {
  name: `AdWatch`,
  path: `/ad-watch/:supportedAssociationId/:adId`
}

export default {
  ...route,

  components: {
    UtilityVideo
  },

  setup () {
    const ad = data.get({
      root: `ads`,
      one: true,
      fetchPolicy: `network-only`,
      fields: [
        `id`, {
          video: [
            `id`,
            `src`
          ],
          image: [
            `id`,
            `src`
          ]
        },
        `pricePerView`
      ],
      request: {
        where: {
          id: {
            _eq: routeCurrent.params.adId
          }
        }
      }
    })
    console.log(routeCurrent.params.adId, ad)

    const routeState = injectRouteState({
      payload: {
        supportedAssociationId: routeCurrent.params.supportedAssociationId,
        adId: null
      },
      shouldReset: true
    })

    theme.isDarkLocally = true
    const video = ref(null)
    const isPlaying = ref(true)
    onUnmounted(() => {
      isPlaying.value = false
    })

    const remainingTime = ref(null)

    const Clock = ({ remainingTime }) => {
      let interval
      onUnmounted(() => {
        clearInterval(interval)
      })
      const play = () => {
        if (isPlaying.value) {
          interval = setInterval(() => {
            if (remainingTime.value !== 1) {
              remainingTime.value--
            } else {
              clearInterval(interval)
              isPlaying.value = false
              onEnded()
            }
          }, 1000)
        }
      }
      const pause = () => {
        clearInterval(interval)
      }
      const set = ({ remainingTime: _remainingTime }) => {
        console.log('_set', remainingTime, _remainingTime)
        remainingTime.value = _remainingTime
      }

      return {
        play,
        pause,
        set
      }
    }

    const clock = Clock({ remainingTime })

    waitFor({
      dependencies: () => ad.value,
    }).then(ad => {
      handleValueOrFunction({
        valueOrFunction: () => isPlaying.value,
        callback: isPlaying => {
          if (ad.image) {
            if (isPlaying) {
              clock.play()
            } else {
              clock.pause()
            }
          }
          theme.dark = isPlaying
            ? true
            : dark
        }
      })
      if (ad.image) {
        clock.set({ remainingTime: 10 })
      }
    })

    page.topBar.set(
      () => !isPlaying.value
        ? ({
          title: `Visionnage d'une annonce`
        }) : null
    )

    const { dark } = theme

    waitFor({
      dependencies: () => ad.value
    }).then(ad => {
      const watchedAt = dayjs()
        .format(`YYYY-MM-DDTHH:mm:ss.SSS`)
      routeState.adId = ad.id
      data.update({
        root: `ads`,
        id: ad.id,
        _set: {
          watchedAt
        },
        fields: [
          `id`,
          `watchedAt`
        ]
      })
    })

    const association = data.get({
      root: `associations`,
      one: true,
      fields: [
        `id`, {
          user: [
            `id`,
            `name`
          ]
        }
      ],
      request: {
        where: {
          id: {
            _eq: routeState.supportedAssociationId
          }
        }
      }
    })

    page.topBar.set(
      () => !isPlaying.value
        ? ({
          title: `Visionnage d'une annonce`
        }) : null
    )

    const onClick = () => {
      isPlaying.value = !isPlaying.value
    }

    const remainingTimeUpdated = value => {
      remainingTime.value = value
    }

    const onEnded = () => {
      router.replace({
        name: `AdWatchSuccess`
      })
    }

    return {
      ad,
      association,
      video,
      isPlaying,
      onClick,
      remainingTimeUpdated,
      remainingTime,
      onEnded
    }
  }
}
</script>
